import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class AddFaq extends Component {
  state = {
    question: "",
    answer: "",

    message: "",
    notification: false,
    notiColor: "success",
    loading: false,
    redirect: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // ✅ CREATE FAQ
  handleSubmit = async (e) => {
    e.preventDefault();

    const { question, answer } = this.state;

    if (!question || !answer) {
      return this.setState({
        notification: true,
        message: "All fields are required!",
        notiColor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const payload = {
      question,
      answer,
      role_id: 1, // ✅ fixed
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(
        Constants.postUrls.createFaq,
        payload
      );

      this.setState({
        notification: true,
        message: resp.data.message || "FAQ created successfully!",
        notiColor: "success",
        loading: false,
      });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        notification: true,
        message:
          err?.response?.data?.message || "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/faqs" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card style={{ padding: 20 }}>

            {/* 🔥 HEADER (YOUR STANDARD) */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Add New FAQ
              </MDTypography>
            </MDBox>

            <form onSubmit={this.handleSubmit}>
              <Grid container spacing={2} mt={1}>

                {/* QUESTION */}
                <Grid item sm={12}>
                  <TextField
                    label="Question"
                    name="question"
                    value={this.state.question}
                    onChange={this.handleInput}
                    fullWidth
                  />
                </Grid>

                {/* ANSWER */}
                <Grid item sm={12}>
                  <TextField
                    label="Answer"
                    name="answer"
                    value={this.state.answer}
                    onChange={this.handleInput}
                    multiline
                    rows={4}
                    fullWidth
                  />
                </Grid>

                {/* SUBMIT */}
                <Grid item sm={12}>
                  <MDButton type="submit" variant="contained" color="info">
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>

              </Grid>
            </form>

          </Card>

          <MDSnackbar
            color={this.state.notiColor}
            title="FAQ"
            content={this.state.message}
            open={this.state.notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}